<script>
export default {
  name: "IconWhiteSearch"
};
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(2 2)"
      stroke="currentColor"
      stroke-width="2.4"
      fill="none"
      fill-rule="evenodd"
    >
      <circle cx="7.6" cy="7.6" r="7.6" />
      <path stroke-linecap="round" d="M13.6 13.6L20 20" />
    </g>
  </svg>
</template>
